import _isEmpty from 'lodash/isEmpty';
import { array, arrayOf, bool, func, object, objectOf, oneOfType, string } from 'prop-types';
import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getURLParameterBykey } from '../../utils';
import {
    analyticsReset,
    onPageReady,
    productFilterApplied,
    promotedFilterReset,
} from '../../actions/AnalyticsActions';

/* istanbul ignore next */
export class StoreAnalytics extends Component {
    static defaultProps = {
        actions: () => {},
        analytics: false || {},
        productList: [] || {},
        requestUrl: '',
        selectedStoresFilter: [],
    };

    static propTypes = {
        actions: objectOf(func),
        analytics: oneOfType([bool, object]),
        productList: oneOfType([array, object]),
        requestUrl: string,
        selectedStoresFilter: arrayOf(object),
    };

    componentDidMount() {
        this.triggerAnalytics();
    }

    shouldComponentUpdate(nextProps) {
        const { selectedStoresFilter, productList } = this.props;

        const {
            analytics: nextAnalytics,
            selectedStoresFilter: newSelectedFilters,
            productList: productListNextProps,
        } = nextProps;

        try {
            const APICallSuccess = nextAnalytics.content === true && nextAnalytics.details === true;
            const isNewFilterSelected = selectedStoresFilter !== newSelectedFilters;
            const isproductListChanged = productList !== productListNextProps;

            if (APICallSuccess || isNewFilterSelected || isproductListChanged) {
                return true;
            }
            return false;
        } catch (e) {
            return true;
        }
    }

    componentDidUpdate() {
        this.triggerAnalytics();
    }

    getAppliedStores = (url) => {
        const curStores = getURLParameterBykey('storeIds', url);

        return curStores === '' ? 0 : curStores.split('-').length;
    };

    triggerAnalytics = () => {
        const { actions, analytics, productList, requestUrl, selectedStoresFilter } = this.props;

        const appliedStores = this.getAppliedStores(requestUrl);
        const productListLoaded = !_isEmpty(productList) && productList.productListLoaded;

        if (!__SERVER__ && (analytics.content || analytics.details) && productListLoaded) {
            const isStoreSelected =
                appliedStores !== 0 && selectedStoresFilter.length === appliedStores;
            const isAppliedAndSelectedStoresEmpty = selectedStoresFilter.length === 0;

            if (isStoreSelected || isAppliedAndSelectedStoresEmpty) {
                actions.onPageReady();
                actions.productFilterApplied();
                actions.promotedFilterReset();
                actions.analyticsReset();
            }
        }
    };

    render() {
        return null;
    }
}

const mapStateToProps = (store) => ({
    analytics: store.analyticsActions,
    productList: store.productList,
    requestUrl: store.commonData ? store.commonData.requestUrl : '',
    selectedStoresFilter: store.bopisInfo.selectedStores,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            analyticsReset,
            onPageReady,
            productFilterApplied,
            promotedFilterReset,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoreAnalytics);
